import React, {useState} from "react"
import {Tab, Stack, Avatar, Chip, Grid} from "@mui/material";
import {checkQueryKey, formatTime, getSellerNames} from "@/helper/method";
import Box from "@mui/material/Box";
import {GridItem} from "@/widget/GridItem/GridItem";
import TabPanel from '@mui/lab/TabPanel';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import {ResultWrapper} from "@/widget/ResultWrapper/ResultWrapper";
import isEmpty from "lodash/isEmpty";
import {GridColDef,} from "@mui/x-data-grid";
import {ProTable} from "@/widget/ProTable/ProTable";
import {TrademarkVO, useQueryTrademark, useQueryTrademarkPage} from "@/service/trademark.s";
import {TrademarkPO} from "@/model/product";
import {ContractDetail} from "@/widget/CommonDetail/ContractDetail";
import {useDrawerModal} from "@/store/global.c";
import {roleAlias, writeStatus} from "@/helper/constant";
import {TaskTable} from "@/widget/CommonDetail/TaskTable";
import {PaybackTable} from "@/widget/CommonDetail/PaybackTable";
import {FileTable} from "@/widget/CommonDetail/FileTable";
import {useAllDict} from "@/store/dict.c";
import {useAuthInfo} from "@/store/account.c";
import {ContactDetail} from "@/widget/CommonDetail/PaybackDetail";

export const ViewTrademark = () => {
    const {id: drawerId} = useDrawerModal()
    const {data: trademarkData, isLoading: trademarkLoading} = useQueryTrademark({id: drawerId!})
    const [tab, setTab] = useState<number>(1)
    const {
        mutate: trademarkPageMutate,
        data: trademarkPageData,
        isPending: trademarkPagePending,
    } = useQueryTrademarkPage(0)
    const trademark = trademarkData?.data || {} as TrademarkVO
    const {trademarkFile} = useAllDict()
    const {role: {roleAlias: roleName}} = useAuthInfo()
    const trademarkColumns: GridColDef<TrademarkPO>[] = [
        {
            field: "trademarkName", headerName: "商标名称", flex: 0.4,
            valueFormatter: value => value || "-",
            renderCell: ({row}) => <Stack alignContent={'center'} alignItems={'center'} direction={'row'} spacing={0.5}>
                {drawerId == row?.id && <Chip size={'small'} variant={'outlined'} color={'primary'} label={"当前"}/>}
                <Box component={'span'}>
                    {isEmpty(row.trademarkName) ? '待定' : row.trademarkName}
                </Box>
            </Stack>
        },
        {
            field: "applyNo",
            headerName: "登记号",
            flex: 0.3,
            valueFormatter: value => value || "-"
        },
        {
            field: "applyDate",
            headerName: "申请日期",
            flex: 0.3,
            valueFormatter: value => formatTime("D", value) || "-"
        },
        {
            field: "assort",
            headerName:
                "类别",
            flex: 0.2,
            renderCell: ({row}) => <Chip color={'secondary'} size={'small'} variant={'outlined'} label={`第${row.category}类`}/>
        }
        ,
        {
            field: "writer",
            headerName:
                "撰稿人",
            flex:
                0.2
        },
    ]

    return <>
        <ResultWrapper isLoading={trademarkLoading} isEmpty={isEmpty(trademark)}>
            <Stack direction={'column'} width={'100%'} gap={2}>
                <Grid
                    spacing={3}
                    container>
                    <GridItem title={'商标图样'}
                              content={<Avatar variant={'square'} sx={{width: 22, height: 22, border: '1px solid #f2f2f2', "& .MuiAvatar-img": {objectFit: 'fill'}}}
                                               src={trademark?.pattern}/>}/>
                    <GridItem title={'商标名称'} content={trademark?.trademarkName}/>
                    <GridItem title={'服务类型'} content={trademark?.category}/>
                    <GridItem title={'申请日期'} content={formatTime("D", trademark?.applyDate)}/>
                    <GridItem title={'登记号'}
                              content={trademark?.applyNo}/>
                    <GridItem title={'申请类别'}
                              content={trademark?.category}/>
                    <GridItem title={'商标状态'} content={trademark?.trademarkStatus}/>
                    <GridItem title={'初审公告日'} content={formatTime("D", trademark?.initialDate)}/>
                    <GridItem title={'初审公告号'} content={trademark?.initialNo}/>
                    <GridItem title={'注册公告日'} content={formatTime("D", trademark?.registerDate)}/>
                    <GridItem title={'注册公告号'} content={trademark?.registerNo}/>
                    <GridItem title={'专有权期限'} content={`${formatTime("D", trademark?.startRightsDate)}至${formatTime("D", trademark?.endRightsDate)}`}/>

                </Grid>
                <TabContext value={tab}>
                    <Stack direction="column" spacing={2}>
                        <Box sx={{borderBottom: 1, borderTop: 1, pt: 1, borderColor: 'divider'}}>
                            <TabList variant={'fullWidth'} onChange={(event, value) => setTab(value)}>
                                <Tab label="详细信息" value={1}/>
                                {/*<Tab label="实施节点" value={6}/>*/}
                                <Tab label="合同" value={2}/>
                                <Tab label="对接人" value={8}/>
                                <Tab label="回款" value={5}/>
                                <Tab label="相关商标" value={3}/>
                                <Tab label="官方文件" value={4}/>
                            </TabList>
                        </Box>
                        <TabPanel value={1} sx={{mt: 1, p: 0}}>
                            <Stack direction={'column'} gap={2}>
                                <Grid
                                    spacing={3}
                                    container>
                                    <GridItem title={'客户名称'} content={trademark?.customerName}/>
                                    <GridItem title={'联系人'} content={trademark?.contact}/>
                                    <GridItem title={'联系电话'} content={trademark?.mobile}/>
                                    <GridItem title={'业务人员'} content={getSellerNames(trademark?.creator, trademark?.seller)}/>
                                    <GridItem title={'价格'} content={trademark?.price}/>
                                    <GridItem title={'接收时间'} content={formatTime("D", trademark?.receiveTime)}/>
                                    <GridItem title={'撰稿人'} content={trademark?.writer}/>
                                    <GridItem title={'撰写状态'} content={trademark?.writeStatus}/>
                                    <GridItem title={`${writeStatus[trademark.writeStatusId] || "撰写"}时间`} content={formatTime("D", trademark?.writeStatusTime)}/>
                                    <GridItem title={'内部期限'} content={formatTime("D", trademark?.insideDeadline)}/>
                                    <GridItem content={trademark?.explain} size={12} minHeight={80} title={'备注'}/>
                                    <GridItem title={'更新时间'} content={formatTime("D", trademark?.updatedAt)}/>
                                    <GridItem title={'创建时间'} content={formatTime("D", trademark?.createdAt)}/>
                                </Grid>
                            </Stack>
                        </TabPanel>
                        <TabPanel value={2} sx={{p: 0}}>
                            <ContractDetail data={trademark?.contract}/>
                        </TabPanel>
                        <TabPanel value={3} sx={{p: 0}}>
                            <ProTable<TrademarkPO> loading={trademarkPagePending} checkboxSelection={false}
                                                   showToolbar={false}
                                                   onSearch={(params) => checkQueryKey(trademark?.contractId) && trademarkPageMutate({
                                                       ...params,
                                                       contractId: trademark?.contractId
                                                   })}
                                                   data={trademarkPageData?.data} pageSize={5}
                                                   columns={trademarkColumns} columnHeaderHeight={46}/>
                        </TabPanel>
                        <TabPanel value={8} sx={{p: 0}}>
                            <ContactDetail id={trademark?.contract?.contactId}/>
                        </TabPanel>
                        <TabPanel value={4} sx={{p: 0}}>
                            <FileTable disabled={!(roleName == roleAlias['processer'])} tag={22} targetId={drawerId} checkboxSelection={true} options={trademarkFile}/>
                        </TabPanel>
                        <TabPanel value={5} sx={{p: 0}}>
                            <PaybackTable enabled={false} data={trademark?.paybacks}/>
                        </TabPanel>
                        <TabPanel value={6} sx={{p: 0}}>
                            <TaskTable/>
                        </TabPanel>
                    </Stack>
                </TabContext>
            </Stack>
        </ResultWrapper>
    </>
};


